import { Globe, Monitor, Moon, Sun } from 'lucide-react';

import { setLang, useLang } from '../i18n.ts';
import { setTheme, useTheme, type ThemeChoice } from '../theme.ts';
import { cx } from './ui.tsx';

export function LanguageToggle() {
  const { t, lang } = useLang();
  return (
    <button
      type="button"
      onClick={() => void setLang(lang === 'ar' ? 'en' : 'ar')}
      className="inline-flex h-10 items-center gap-1.5 rounded-lg px-2.5 text-sm font-semibold hover:bg-surface-2"
      lang={lang === 'ar' ? 'en' : 'ar'}
      aria-label={`${t('language.label')}: ${t('language.switchTo')}`}
    >
      <Globe className="size-4" aria-hidden />
      <span>{t('language.switchTo')}</span>
    </button>
  );
}

/** System / light / dark (CLAUDE.md §8: follow the device, with a manual choice). */
export function ThemeToggle() {
  const { t } = useLang();
  const theme = useTheme();
  const options: { value: ThemeChoice; icon: typeof Sun; label: string }[] = [
    { value: 'system', icon: Monitor, label: t('theme.system') },
    { value: 'light', icon: Sun, label: t('theme.light') },
    { value: 'dark', icon: Moon, label: t('theme.dark') },
  ];
  return (
    <div
      role="group"
      aria-label={t('theme.label')}
      className="flex rounded-lg border border-border p-0.5"
    >
      {options.map((option) => {
        const Icon = option.icon;
        const active = theme === option.value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={active}
            title={option.label}
            aria-label={option.label}
            onClick={() => {
              setTheme(option.value);
            }}
            className={cx(
              'rounded-md p-1.5',
              active ? 'bg-surface-2 text-text' : 'text-muted hover:text-text',
            )}
          >
            <Icon className="size-4" aria-hidden />
          </button>
        );
      })}
    </div>
  );
}
